/// <amd-module name="TFS/Security/Common/Contracts" />

import { MessageCardSeverity } from "VSSUI/MessageCard";

export interface ISecurityViewData {
    title: string;
    hasSingleCollectionAdmin: boolean;
    isAadGroupsAdminUi: boolean;
    permissionsContextJson: string;
    securityViewOptionsJson: string;
    userHasReadAccess: string;
    userIsCollectionAdmin: boolean;
}

export interface IMessageCardContent {
    severity: MessageCardSeverity;
    message: string;
}
